import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';

import { StatusReportRow, STATUS_REPORT_COLUMNS } from '../../../interfaces/status-report.interface';

interface StatusReportDisplayRow {
  name: string;
  counts: Record<string, number>;
  isTotal: boolean;
}

@Component({
  selector: 'app-status-report-table',
  imports: [CommonModule, MatTableModule],
  templateUrl: './status-report-table.component.html',
  styleUrl: './status-report-table.component.scss'
})
export class StatusReportTableComponent implements OnChanges {
  @Input() rows: StatusReportRow[] = [];

  readonly statusColumns = STATUS_REPORT_COLUMNS;
  readonly displayedColumns: string[] = ['name', ...STATUS_REPORT_COLUMNS.map(c => c.value)];

  displayRows: StatusReportDisplayRow[] = [];

  ngOnChanges(): void {
    this.buildDisplayRows();
  }

  private buildDisplayRows(): void {
    const unassigned = this.rows.filter(r => r.userId === null);
    const activeUsers = this.rows.filter(r => r.userId !== null && r.isActive);
    const inactiveUsers = this.rows.filter(r => r.userId !== null && !r.isActive);

    const totalCounts: Record<string, number> = {};
    for (const column of this.statusColumns) {
      totalCounts[column.value] = this.rows.reduce(
        (sum, row) => sum + (row.counts[column.value] ?? 0),
        0
      );
    }

    this.displayRows = [
      { name: 'Összes', counts: totalCounts, isTotal: true },
      ...unassigned.map(r => ({ name: r.fullName, counts: r.counts, isTotal: false })),
      ...activeUsers.map(r => ({ name: r.fullName, counts: r.counts, isTotal: false })),
      ...inactiveUsers.map(r => ({ name: `${r.fullName} (inaktív)`, counts: r.counts, isTotal: false }))
    ];
  }
}
